import axios from 'axios';
import { getAdhocAdvanceReportQuery } from './queries';

const getAdhocAdvanceReport = (id) =>
    new Promise((resolve, reject) => {
        const query = getAdhocAdvanceReportQuery({ id });
        const request = axios.get(query);

        request
            .then((response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to get adhoc pay report'));
            });
    });

export default getAdhocAdvanceReport;
